import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { LoginserviceService } from '../services/services/loginservice.service';
import { AppdataService } from '../services/services/appdata.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { ViewChildren } from '@angular/core';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  @ViewChildren('input')firstipcontrol;
//Save Validation
submitted:boolean;
successfully:boolean;

userColl:any=[];

 loginform=new FormGroup({
   username:new FormControl('',Validators.required),         
   userpwd:new FormControl('',Validators.required),
});


 constructor(private loginService: LoginserviceService,private appService: AppdataService,
   private toastr: ToastrService,public router: Router) { }

 ngOnInit() {
   this.fnInitializeFormGroup();
   
   //setTimeout(() => this.appService.islogin = false);
      this.loginService.islogin=false;
 }
 ngAfterViewInit()
 {
   setTimeout(() => {
     document.getElementById('txtusername').focus()
   }, 200);
   //this.firstipcontrol.first.nativeElement.focus();
 }

   ngAfterViewChecked(){
     this.loginService.islogin = true;

   }

   fnInitializeFormGroup(){
   this.loginform.setValue({
     username:'',      
     userpwd:''
   })
}

 fnLogin(){
   try{
     this.submitted=true;
     this.successfully=false;
     //Validate
     if(this.loginform.valid){
       var data = {
         'username':this.loginform.get('username').value, 
         'userpwd':this.loginform.get('userpwd').value, 
       }

       
      //  this.appService.getDesignationCompany(data)
      //  .subscribe(
      //    (res)=>{   
      //      console.log(res);            
      //      if(res.json().status===200){
      //        this.userColl=res.json().result;  
      //       //  if(this.userColl){

      //       //    if(this.userColl.length>0){
      //       //        sessionStorage.setItem('hrtoken', JSON.stringify(this.userColl[0].userid));                      
      //       //        this.loginService.islogin = false;
                 
      //       //        this.fnInsertActivityLog('LOGIN',this.userColl[0].loginuserid,this.userColl[0].username);
                   
      //       //        this.router.navigate(['/']).then(()=>{
      //       //          window.location.reload();
      //       //        });
                   
      //       //    }else{
      //       //      this.loginform.controls['userpwd'].setErrors({'notfound': true});
      //       //    }

      //       //  }

      //      }   
                    
      //  },
      //  (err)=>{          
      //    this.toastr.error('Error', err);
      //    })
       

       this.appService.getLoginUser(data)
       .subscribe(
         (res)=>{   
           console.log(res.json().result);            
           if(res.json().status===200){
             this.userColl=res.json().result;  
             if(this.userColl){

               if(this.userColl.length>0){
                   sessionStorage.setItem('hrtoken', JSON.stringify(this.userColl[0].userid));                      
                   this.loginService.islogin = false;
                 
                   this.fnInsertActivityLog('LOGIN',this.userColl[0].loginuserid,this.userColl[0].username);
                   
                   this.router.navigate(['/']).then(()=>{
                     window.location.reload();
                   });
                   
               }else{
                 this.loginform.controls['userpwd'].setErrors({'notfound': true});
               }

             }

           }   
                    
       },
       (err)=>{          
         this.toastr.error('Error', err);
       })
      }
   }catch(ex){
     this.fnShowErrorMsg(ex);
   }
 }

  
  
  
 fnInsertActivityLog(action,refno,desc){
  try{
    var data={
      logtype:action,
      logat:"LOGIN",
      refnum:refno,
      logdescr:desc,companyid: this.loginService.fnGetCompanyId(),         
      logby:refno,
    }
  

    this.appService.fnInsertActivity(data).subscribe(
      (res)=>{
      },
      (err)=>{
     
      });

  }catch{

  }
 }
  
 private  fnShowErrorMsg(ex){
   this.toastr.warning('Internal Error', ex);       
 }

}
